<script setup lang="ts">
import type { ImageValue } from './BaseImage.vue'

const missingCountries = ['zz', 'cs', 'ct', 'nq', 'fq', 'jt', 'fx', 'mi', 'nt', 'vd', 'pc', 'pz', 'pu', 'su', 'wk']

const props = defineProps<{
  iso2?: string | None
  country?: { iso2: string; img?: ImageValue | None } | None
}>()

const IMG_HOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

function getUrl(codeArg: string): string {
  if (!codeArg || typeof codeArg !== 'string') return IMG_HOLDER
  const code = codeArg.toLowerCase()
  if (missingCountries.includes(code)) return IMG_HOLDER
  return `/countries/${code}.svg`
}

const ui = toRef(() => {
  const { iso2: isoDef, country } = props
  const iso2 = country?.iso2 || isoDef
  return {
    alt: `${iso2} flag`,
    iso2,
    img1: country?.img,
    img2: iso2 ? getUrl(iso2) : IMG_HOLDER,
  }
})
</script>

<template>
  <span :class="[$style.img, ui.img1 ? $style.img1 : $style.img2]">
    <BaseImage v-if="ui.img1" :img="ui.img1" sizes="fixed:50" fit="center" class="_h16 _flex" :alt="ui.alt" height="36" width="44" />
    <img v-else :src="ui.img2" :alt="ui.alt" height="36" width="44">
  </span>
</template>

<style module>
.img {
  composes: global(_relative);
  composes: global(_h18);
  composes: global(_ctr);
  composes: global(_hidden);

  composes: global(_noflex);
  composes: global(_bg5);

  box-sizing: content-box;
  margin: auto 0;
  border-radius: 6px/5px;
  width: 22px;
}
.img2 img {
  flex: 0 0 20px;
  height: 20px;
}
/* if img breaks */
.img img:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  height: auto;
  width: 100%;
  background-color: #f5f5f5;
  z-index: 1;
}
</style>
